// extracted by mini-css-extract-plugin
module.exports = {"title":"PopinTitle_title__22mUP"};